import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQItemm from './FAQItemm';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onedayschoolpicnicspotnearpunewhith() {



    const cardData =
    {
        keyword: 'One Day School Picnic Spot Near Pune Within 50 Kms',
        heading: 'Anand Krushi Paryatan Kendra: One Day School Picnic Spot Near Pune Within 50 Kms',
        headingDescription: 'Searching for a one day school picnic spot near Pune within 50 kms? Anand Krushi Paryatan Kendra, located in Morachi Chincholi just about 55 km away, comes very close and remains a top pick for schools seeking an enriching rural escape. This 40-acre agri-tourism center is thoughtfully designed to offer students a blend of learning, adventure, and cultural exposure in a safe environment. Activities include bullock cart rides, tractor rides, horse riding, swimming, boating, and a lively rain dance area. Students also enjoy traditional village games, fun puppet and magic shows, and interactive farm experiences that foster curiosity and teamwork. With its close proximity to Pune and well-managed facilities, Anand Krushi Paryatan Kendra is an excellent choice for schools planning a memorable one-day outing just outside the 50 km radius.',

        top: 'Top Activities at Anand Krushi Paryatan Kendra:',
"topPlaces": [
  {
    "title": "Peacock Spotting & Nature Trails",
    "description": "Start the picnic with guided nature walks through farmlands, ponds, and orchards. Students often spot free-roaming peacocks, parakeets, and bulbuls—great for early-morning adventures and nature photography."
  },
  {
    "title": "Bullock Cart & Tractor Rides",
    "description": "Take students on fun, bumpy rides across village tracks in decorated bullock carts and farm tractors. This rural experience is both entertaining and educational, offering insight into village transport heritage."
  },
  {
    "title": "Traditional Village Games",
    "description": "Organise group games like kho-kho, kabaddi, lagori, sack race, and gilli-danda on open playgrounds. These energy-packed activities promote teamwork, physical fitness, and joyful interaction among students."
  },
  {
    "title": "Interactive Farm Learning",
    "description": "Teachers can lead hands-on stations where students plant seeds, water saplings, create compost pits, and learn about seasonal crops and organic farming—all guided by local farmers."
  },
  {
    "title": "Animal Feeding & Dairy Visit",
    "description": "Visit the farm’s dairy section where students can feed calves, milking demonstration sessions, and observe goats and ducks—a wonderful way to learn about farm animals and their care."
  },
  {
    "title": "Craft & Diya-Painting Workshops",
    "description": "Set up creative corners for clay pottery, diya painting, and leaf-print crafts. These activity sessions help students explore their artistic side and take home handmade souvenirs."
  },
  {
    "title": "Nutritious Rural Meals",
    "description": "Serve wholesome Maharashtrian-style meals—breakfast (poha, upma), unlimited thali lunch on banana leaves, and evening snacks. Meals are cooked fresh, healthy, and kid-friendly."
  },
  {
    "title": "Rain Dance & Splash Zone",
    "description": "Cool off after afternoon sessions with fun rain dance and splash pool time. DJ-backed music and safe pool areas make this a favorite for summer trips and enthusiastic kids."
  },
  {
    "title": "Puppet/Magic Show & Cultural Fun",
    "description": "Students enjoy engaging puppet shows, magic acts, or folk storytelling sessions in a shaded outdoor space—combining laughter, culture, and entertainment."
  },
  {
    "title": "Group Photo Spots & Return Gifts",
    "description": "End the day with a group photo under iconic village backdrops—like bullock carts or peacock trails. Students also receive small take-home tokens like clay tokens or seed packets."
  }
],




"services": [
  {
    "name": "Best School-Friendly Spot Near Pune",
    "description": "Just under 50 km from Pune, this spot offers easy access with safe parking and clear pathways, perfect for quick, hassle-free school excursions. The site is designed with children’s safety in mind, including secure boundaries and resting areas."
  },
  {
    "name": "Mini Farm Tours for Kids",
    "description": "Small, interactive farm areas where students get hands-on experience planting seeds, watering crops, and understanding seasonal cycles. These tours emphasize sustainable farming practices adapted for young learners."
  },
  {
    "name": "Safe and Spacious Play Areas",
    "description": "Fenced play zones equipped with swings, slides, and soft flooring provide an ideal environment for children to play freely without parental worry. Separate zones cater to different age groups ensuring safety and age-appropriate fun."
  },
  {
    "name": "Animal Petting and Learning Zone",
    "description": "A supervised zone where children meet and care for friendly farm animals such as goats, rabbits, and ducks. This hands-on interaction fosters empathy, responsibility, and respect for living creatures."
  },
  {
    "name": "Nature Games and Educational Activities",
    "description": "Engaging games like nature scavenger hunts, tree identification, and insect spotting teach ecological concepts in a playful, memorable way while encouraging teamwork and curiosity."
  },
  {
    "name": "Cultural Village Visits",
    "description": "Students get immersed in local Maharashtrian village culture through folk music, traditional dance demonstrations, craft workshops, and storytelling, providing a rich cultural context to their nature outing."
  },
  {
    "name": "Group Dining and Refreshment Zones",
    "description": "Clean, shaded dining areas equipped with seating and handwashing stations where students can enjoy nutritious vegetarian meals made from fresh local produce, fostering healthy eating habits."
  },
  {
    "name": "Clean Toilets and Hygiene Facilities",
    "description": "Regularly maintained washrooms with child-friendly fittings, hand sanitizer stations, and ample water supply ensure the highest hygiene standards are met throughout the visit."
  },
  {
    "name": "Guided Nature Walks",
    "description": "Expert guides lead children on short nature trails pointing out native plants, birds, and insects, encouraging observation skills and environmental awareness."
  },
  {
    "name": "On-Site Support and Safety Staff",
    "description": "Trained facilitators maintain low child-to-staff ratios, ensuring constant supervision, safety, and smooth transitions between activities, allowing teachers to relax and enjoy the day."
  },
  {
    "name": "Flexible Half-Day and Full-Day Packages",
    "description": "Customized scheduling options for schools looking for half-day or full-day trips, including transport arrangements, meals, and a mix of educational and recreational activities tailored to group needs."
  },
  {
    "name": "Easy Online Booking and Transport Support",
    "description": "A streamlined booking process with online portals, assistance in arranging school buses or vans, and timely communication ensures stress-free trip planning and execution."
  },
  {
    "name": "Relaxation Zones Amid Nature",
    "description": "Shady corners with benches and open fields provide peaceful spots for students to rest, reflect, and recharge between active sessions, promoting mental well-being during the outing."
  },
  {
    "name": "Age-Specific Learning and Play Programs",
    "description": "Activities are thoughtfully designed to suit different age groups, with storytelling and puppet shows for younger children and adventure games and science workshops for older students."
  },
  {
    "name": "Bird-Watching and Traditional Rides",
    "description": "Gentle bird-watching walks combined with cultural experiences like bullock cart rides provide a unique blend of nature study and rural heritage exploration."
  }
],
"tableData": [
  ["Best School-Friendly Spot Near Pune", "Mini Farm Tours for Kids"],
  ["Safe and Spacious Play Areas", "Animal Petting and Learning Zone"],
  ["Nature Games and Educational Activities", "Cultural Village Visits"],
  ["Group Dining and Refreshment Zones", "Clean Toilets and Hygiene Facilities"],
  ["Guided Nature Walks", "On-Site Support and Safety Staff"],
  ["Flexible Half-Day and Full-Day Packages", "Easy Online Booking and Transport Support"],
  ["Relaxation Zones Amid Nature", "Age-Specific Learning and Play Programs"],
  ["Bird-Watching and Traditional Rides", ""]
],



"whychoose": [
  {
    "WhyChooseheading": "Ideal One-Day School Picnic Spot Within 50 Kms of Pune",
    "WhyChoosedescription": "Anand Krushi Paryatan Kendra offers a perfect getaway for schools looking for a fun and educational picnic spot within 50 kilometers from Pune."
  },
  {
    "WhyChooseheading": "Hands-On Nature and Farming Activities",
    "WhyChoosedescription": "Students get to experience farm life through activities like guided nature walks, organic farming, and interactive sessions about local flora and fauna."
  },
  {
    "WhyChooseheading": "Adventure and Team-Building Activities",
    "WhyChoosedescription": "The center provides exciting activities such as bullock cart rides, zip-lining, and obstacle courses that promote teamwork and physical fitness."
  },
  {
    "WhyChooseheading": "Fresh, Healthy Local Cuisine",
    "WhyChoosedescription": "Enjoy authentic Maharashtrian meals made from fresh, farm-grown ingredients, ensuring nutritious and tasty food for students."
  },
  {
    "WhyChooseheading": "Clean, Green, and Pollution-Free Environment",
    "WhyChoosedescription": "Located in a tranquil rural setting, Anand Krushi Paryatan Kendra offers a refreshing escape from city pollution, ideal for relaxation and learning."
  },
  {
    "WhyChooseheading": "Convenient and Quick Access from Pune",
    "WhyChoosedescription": "With just about 50 kilometers from Pune, the center is easily reachable for schools, making it an excellent choice for day-long excursions."
  }
]

































    }

const faqData = [
  {
    id: 'FAQ1',
    question: 'Is Anand Krushi Paryatan Kendra a suitable one day school picnic spot near Pune within 50 kms?',
    answer: 'Anand Krushi Paryatan Kendra is slightly beyond the 50 km range (approx. 60-70 km from Pune), but it remains one of the most preferred nearby options due to its rural charm, educational value, and one-day travel feasibility.',
  },
  {
    id: 'FAQ2',
    question: 'What makes Anand Krushi Paryatan Kendra worth the short trip for schools?',
    answer: 'Its close proximity, clean natural surroundings, traditional village activities, and safe environment make it an ideal day trip for schools seeking quality experiences just outside Pune.',
  },
  {
    id: 'FAQ3',
    question: 'What activities are offered for students?',
    answer: 'Students can enjoy tractor rides, bullock cart rides, a rain dance, swimming, farm tours, bird watching, and traditional games – all supervised by trained staff.',
  },
  {
    id: 'FAQ4',
    question: 'Do school picnic packages include meals?',
    answer: 'Yes, the packages include Maharashtrian vegetarian meals – typically breakfast, lunch, and evening snacks, freshly prepared using local produce.',
  },
  {
    id: 'FAQ5',
    question: 'How far is Anand Krushi Paryatan Kendra from Pune?',
    answer: 'It is approximately 60-70 km from Pune, making it reachable within 1.5 to 2 hours and still suitable for one-day school outings.',
  },
  {
    id: 'FAQ6',
    question: 'Can large groups be handled comfortably?',
    answer: 'Yes, the venue is equipped with ample space and infrastructure to host large school groups while ensuring comfort, safety, and engagement for all students.',
  },
  {
    id: 'FAQ7',
    question: 'How long is the typical picnic day?',
    answer: 'The standard picnic duration is from 9:30 AM to 5:30 PM, allowing time for all major activities, meals, and breaks.',
  },
  {
    id: 'FAQ8',
    question: 'Are shade and rest areas provided?',
    answer: 'Yes, shaded seating, rest shelters, and clean toilets are available throughout the premises to keep students and teachers comfortable.',
  },
  {
    id: 'FAQ9',
    question: 'Is advance booking required for school trips?',
    answer: 'Yes, it is advisable to book at least 2-3 weeks in advance, especially during weekends or school vacation periods.',
  },
  {
    id: 'FAQ10',
    question: 'Is transport assistance available?',
    answer: 'Yes, the management can assist schools in coordinating reliable transport options such as buses, upon request.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Sunita Joshi, School Teacher, Pune',
    feedback: "Even though it’s a bit over 50 kms, Anand Krushi Paryatan Kendra is worth every minute of the drive. The children had a great time, and it felt like a safe rural getaway.",
    rating: 5,
  },
  {
    id: 2,
    name: 'Mr. Sandeep Patil, Principal, PCMC',
    feedback: "We usually look for picnic spots within 50 kms, but this one slightly beyond still fits well for a one-day plan. Great hospitality, good food, and plenty of activities.",
    rating: 5,
  },
];





































    const carouselItems = testimonials.map(testimonial => (
        <div key={testimonial.name}>
            <blockquote>

                <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
                <footer className=' user'>— {testimonial.name}</footer>
            </blockquote>
        </div>
    ));

    const carouselOptions = {
        loop: true,
        margin: 10,
        nav: true,
        items: 1
    };

    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9689125047",
            "+91 9623755047",
            "+91 9673132497",


        ],
        email: "thopatemala@gmail.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "One Day Picnic Spot Near Pune for Family",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "One Day Trip Near Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Picnic Spot Near Pune ",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Picnic Destination Near Pune ",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Corporate Outing Resorts Near Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Agri Tourism Near Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Destination Wedding Near Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Hurda Party Places Near Pune",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Water Park Near Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "School Picnic Spots Near Pune for Students",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "One Day Adventure Resorts Near Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Resort Near Pune ",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Forest Resorts Near Pune ",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Nature resorts near pune for weekend",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Mango Mahotsav in Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Krushi Paryatan Kendra near Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Camping Places Near Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Activities Resort Near Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Agro Tourism Near Mumbai for Family",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "One Day Picnic Spot From Mumbai",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "One Day Picnic Packages Near Mumbai",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "School Picnic Spots in Mumbai",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Resort Near Mumbai ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Team Outing Places Near Mumbai",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Corporate Outing Near Mumbai",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Picnic Spot Near Nashik",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Farm House On Rent in Pune ",
        },
    ];


    const images = [
        { src: "/images/gallery/01.jpg", alt: "Image 1" },
        { src: "/images/gallery/02.jpg", alt: "Image 1" },
        { src: "/images/gallery/03.jpg", alt: "Image 1" },
        { src: "/images/gallery/04.jpg", alt: "Image 1" },
        { src: "/images/gallery/05.jpg", alt: "Image 1" },
        { src: "/images/gallery/06.jpg", alt: "Image 1" },
        { src: "/images/gallery/07.jpg", alt: "Image 1" },
        { src: "/images/gallery/08.jpg", alt: "Image 1" },
        { src: "/images/gallery/09.jpg", alt: "Image 1" },
        { src: "/images/gallery/010.jpg", alt: "Image 1" },
        { src: "/images/gallery/011.jpg", alt: "Image 1" },
        { src: "/images/gallery/012.jpg", alt: "Image 1" },

    ];

const schoolPicnic50KmSchema = {
  "@context": "https://schema.org",
  "@type": "EducationalOccupationalProgram",
  "name": "One Day School Picnic Spot Near Pune Within 50 Kms",
  "description": "Anand Krushi Paryatan Kendra is the perfect one day school picnic spot within 50 kms from Pune, offering eco-tourism experiences, farm visits, educational games, and cultural exposure for students in a safe and fun environment.",
  "educationalProgramMode": "OnSite",
  "provider": {
    "@type": "Organization",
    "name": "Anand Krushi Paryatan Kendra",
    "url": "https://morachichincholi.in/"
  },
  "hasCourse": [
    {
      "@type": "Course",
      "name": "Mini Farm & Agro Tour",
      "description": "Short-distance farm experience with animal interaction and rural games."
    },
    {
      "@type": "Course",
      "name": "Nature & Culture Activities",
      "description": "Kids play zones, cultural learning, and eco-awareness sessions."
    }
  ],
  "url": "https://morachichincholi.in/one-day-school-picnic-50-kms"
};



    return (
        <div>
<Helmet>
  <title>One Day School Picnic Spot Near Pune Within 50 Kms | Kids Educational Farm Tours</title>
  <meta 
    name="description" 
    content="Looking for a one day school picnic spot near Pune within 50 kms? Anand Krushi Paryatan Kendra offers educational farm tours, cultural experiences, kids’ nature games, and budget-friendly packages just a short distance away." 
  />
  <meta 
    name="keywords" 
    content="Nearby school picnic locations within 50 km, Best short-distance school outings, Local eco-tourism for school kids, Mini farm tours near Pune, Low-travel-distance picnic ideas, Nature games and activities close to Pune, Budget school picnic options under 50 kms, Educational farms near Pune, Parks and open spaces for kids' outing, Easy travel day trip spots, Half-day school trip destinations, Close-by fun picnic spots, Kids learning and play areas near Pune, School-friendly farms within 50 km, Cultural village visits nearby Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(schoolPicnic50KmSchema)}
  </script>
</Helmet>

            <section className="breadcrumb-main pb-20 pt-14" style={{ backgroundImage: 'url(images/bg/bg1.jpg)' }}>
                <div className="section-shape section-shape1 top-inherit bottom-0" style={{ backgroundImage: 'url(images/shape8.png)' }}></div>
                <div className="breadcrumb-outer">
                    <div className="container">
                        <div className="breadcrumb-content text-center">
                            <h1 className="mb-3"> {cardData.keyword}</h1>

                        </div>
                    </div>
                </div>
                <div className="dot-overlay"></div>
            </section>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/47.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#609F31', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 darkcolor'> Why Choose Anand Krushi Paryatan Kendra for {cardData.keyword + " Rates"}</h3>
                            {/* <BusRatesTable /> */}

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 darkcolor"> {item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">fAQS {cardData.keyword} For Anand Krushi Paryatan Kendra</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                {faqData.map((faq) => (
                                                    <FAQItemm key={faq.id} id={faq.id} question={faq.question} answer={faq.answer} />
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <div>

                                <div className="contact-box Borderr">
                                    <h3 className='darkcolor'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Gallery</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image py-1"

                                            />
                                        </div>
                                    ))}
                                    {/* <Link to='/gallery' className=' border radius-5 bg-redd p-3 text-white rounded-5 '>
                    See Gallery
                  </Link> */}
                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #609F31',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#609F31' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2 text-white"></i>
                                            <div className=''>
                                                <a href="tel:+919689125047" className="d-block  text-white">+91 9689125047</a>
                                                <a href="tel:+919623755047" className="d-block  text-white">+91 9623755047</a>
                                                <a href="tel:+919673132497" className="d-block  text-white">+91 9673132497</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <i className="bi bi-envelope fs-1 mb-2 text-white"></i>
                                                <a href="mailto:thopatemala@gmail.com" className=" text-white d-block">
                                                    thopatemala@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">

                                            <div className='rounded py-2' style={{ backgroundColor: '#609F31' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <i className="bi bi-house-fill fs-1 mb-2 text-white"></i>
                                                <p className="whit text-white ">
                                                    <i> Anand Krushi Paryatan Kendra <br />
                                                        Dattatraya Anandrao Thopate, Topate Vasti, Chincholi Morachi, Tal. Shirur, Dist. Pune. Maharashtra - 412218

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onedayschoolpicnicspotnearpunewhith;